<template>
  <i v-if="showEmoji" :class="className">{{ iconContent }}</i>
  <fluent-icon
    v-else-if="showIcon"
    :size="iconSize"
    :icon="fluentIconName"
    :type="fluentIconType"
    class="flex-shrink-0"
    :class="className"
  />
</template>

<script>
import { hasEmojiSupport } from 'shared/helpers/emoji';
import { mapGetters } from 'vuex';

const ICON_TYPE_PATTERN = /^(.*)-(outline|filled|solid)$/;

export default {
  props: {
    icon: { type: String, default: '' },
    iconSize: { type: [Number, String], default: 20 },
    emoji: { type: String, default: '' },
  },
  computed: {
    ...mapGetters({ uiSettings: 'getUISettings' }),
    isIconTypeEmoji() {
      const { icon_type: iconType } = this.uiSettings || {};
      return iconType === 'emoji';
    },
    showEmoji() {
      return this.isIconTypeEmoji && this.emoji && hasEmojiSupport(this.emoji);
    },
    isSvgIcon() {
      return !this.showEmoji && this.icon && this.icon.endsWith('-outline');
    },
    showIcon() {
      return !this.showEmoji && this.icon;
    },
    iconContent() {
      return this.showEmoji ? this.emoji : '';
    },
    fluentIconName() {
      const iconMatch = this.icon.match(ICON_TYPE_PATTERN);
      return iconMatch ? iconMatch[1] : this.icon;
    },
    fluentIconType() {
      const iconMatch = this.icon.match(ICON_TYPE_PATTERN);
      return iconMatch ? iconMatch[2] : 'outline';
    },
    className() {
      return {
        'icon--emoji': this.showEmoji,
        'icon--font': this.showIcon && !this.isSvgIcon,
        'icon--svg': this.isSvgIcon,
        [this.icon]: this.showIcon,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.icon--emoji {
  font-style: normal;
}

.icon--svg {
  @apply inline-flex;
}
</style>
